import { logoutAndRedirect } from "api/user";
import { useGetNotification } from "api/investor/queries";
import { isOpenTime } from "components/CommonSidebar/Sidebar";
import { Text } from "components/InvestorCommon/TextV2";
import { useAppDispatch, useAppSelector } from "hooks/reduxHook";
import { useAuthPermissions } from "hooks/useAuthUser";
import Cookies from "js-cookie";
import { routesEnum } from "pages/Routes";
import { FC } from "react";
import {
	Menu,
	MenuItem,
	ProSidebar,
	SidebarContent,
	SidebarFooter,
	SubMenu,
} from "react-pro-sidebar";
import {
	CollapseIconButton,
	Image,
	WrapperMobileSidebar,
	WrapperProSidebar,
	WrapperrSideBar,
	collapseIcon,
	expandIcon,
} from "./styled";
import "react-pro-sidebar/dist/css/styles.css";
import { useHistory, useLocation } from "react-router-dom";
import { getUser } from "store/ducks/investor/slice";
import { setType } from "store/ducks/system/slice";
import { PERMISSIONS } from "utils/constant";
import { IMAGES } from "utils/images";

interface Props {
	menuCollapse: any;
	setMenuCollapse: any;
}

interface ISidebar {
	subMenu?: boolean;
	title: string;
	link: string;
	icon?: any;
	subItem?: ISidebar[];
}

const TOP_SIDEBAR = (isShowTrading: boolean): ISidebar[] => [
	{
		title: "Home",
		link: "/investors",
		icon: <Image width="20px" height="20px" src={IMAGES.sidebar.home} />,
	},
	{
		subMenu: true,
		title: "Wallet",
		link: "/investors/wallet",
		icon: <Image width="20px" height="20px" src={IMAGES.sidebar.wallet} />,
		subItem: [
			{
				title: "Wallet Details",
				link: "/investors/wallet",
			},
			{
				title: "Token Details",
				link: "/investors/token-detail",
			},
			{
				title: "Transactions",
				link: "/investors/transactions",
			},
		],
	},
	{
		subMenu: true,
		title: "Platforms",
		link: "/investors/primary-listing",
		icon: <Image width="20px" height="20px" src={IMAGES.sidebar.platforms} />,
		subItem: [
			{
				title: "Primary Listing",
				link: "/investors/primary-listing",
			},
			...(isShowTrading
				? [
						{
							title: "Trading Platform",
							link: "/investors/trading-platform",
						},
					]
				: []),
		],
	},
	{
		title: "Announcement",
		link: "/investors/announcement-list",
		icon: <Image width="20px" height="20px" src={IMAGES.sidebar.announcement} />,
	},
];

const FOOTER_SIDEBAR_WITH_CORP: ISidebar[] = [
	{
		subMenu: true,
		title: "Settings",
		link: "/investors/setting",
		icon: <Image width="20px" height="20px" src={IMAGES.sidebar.settings} />,
		subItem: [
			{
				title: "Account",
				link: "/investors/coporate/account",
			},
			{
				title: "Company Info",
				link: "/investors/coporate/companyInfo",
			},
			{
				title: "User Management",
				link: "/investors/coporate/userManagement",
			},
			{
				title: "Referral",
				link: "/investors/referral",
			},
		],
	},
];

const FOOTER_SIDEBAR_WITHOUT_CORP: ISidebar[] = [
	{
		subMenu: true,
		title: "Settings",
		link: "/investors/setting",
		icon: <Image width="20px" height="20px" src={IMAGES.sidebar.settings} />,
		subItem: [
			{
				title: "Account",
				link: "/investors/individual/account",
			},
			{
				title: "Investor Info",
				link: "/investors/individual/investorInfo",
			},
			{
				title: "Referral",
				link: "/investors/referral",
			},
		],
	},
];

const FOOTER_SIDEBAR_WITH_ISSUER: ISidebar[] = [
	{
		subMenu: true,
		title: "Settings",
		link: "/issuer/setting",
		icon: <Image width="20px" height="20px" src={IMAGES.sidebar.settings} />,
		subItem: [
			// {
			//   title: 'Account',
			//   link: '/issuer/account',
			// },
			{
				title: "Issuer Info",
				link: "/issuer/issuerInfo",
			},
			{
				title: "Documents",
				link: "/issuer/documents",
			},
			// {
			//   title: 'User Management',
			//   link: '/issuer/authorizedIssuerInfo',
			// },
			{
				title: "Referral",
				link: "/investors/referral",
			},
		],
	},
];

const SideBarHeadOptions = () => {
	const dataUser = useAppSelector(getUser);

	const { data: response = {} } = useGetNotification(dataUser?.id || "", {
		enabled: !!dataUser?.id,
	});
	const listNotification = response.data || [];
	return (
		<div className="z-50 flex flex-row items-center gap-6 pl-4">
			<div className="relative cursor-pointer">
				<img src={IMAGES.header.news} />
				<span className="-translate-y-2 absolute top-0 right-0 inline-block h-2 w-2 translate-x-2 transform rounded-full bg-orange-600"></span>
			</div>
			<div className="relative cursor-pointer">
				<img src={IMAGES.header.notification} />
				<span className="-translate-y-4 absolute top-0 right-0 inline-flex translate-x-5 transform items-center justify-center rounded-full bg-orange-600 px-2 py-1 font-bold text-orange-100 text-xs leading-none">
					{listNotification.length}
				</span>
			</div>
		</div>
	);
};

const SidebarMoblie: FC<Props> = ({ menuCollapse, setMenuCollapse }) => {
	const history = useHistory();
	const dispatch = useAppDispatch();
	const permissions = useAuthPermissions();

	const location = useLocation();

	const FOOTER_SIDEBAR = permissions.includes(PERMISSIONS.WEB_INVESTOR_CORP_MANAGE)
		? FOOTER_SIDEBAR_WITH_CORP
		: permissions.includes(PERMISSIONS.WEB_ISSUER_AUTHORIZE)
			? FOOTER_SIDEBAR_WITH_ISSUER
			: FOOTER_SIDEBAR_WITHOUT_CORP;

	const isShowTrading =
		isOpenTime() ||
		(process.env.WEB_KLDX_SHOW_TRADING_PLATFORM_MENU === "TRUE" &&
			process.env.WEB_KLDX_SHOW_TRADING_PLATFORM === "TRUE");

	return (
		<WrapperrSideBar
			className="mobile"
			style={{ width: !menuCollapse ? "290px" : "0px", maxWidth: "100%" }}
		>
			<CollapseIconButton className={`${menuCollapse ? "expand" : "kldx-collapse"}`}>
				<img
					src={menuCollapse ? expandIcon : collapseIcon}
					alt=""
					onClick={() => setMenuCollapse()}
				/>
			</CollapseIconButton>
			<WrapperProSidebar>
				<ProSidebar collapsed={menuCollapse}>
					<SidebarContent>
						<WrapperMobileSidebar>
							<SideBarHeadOptions />
						</WrapperMobileSidebar>
						<Menu iconShape="square">
							{TOP_SIDEBAR(isShowTrading).map((item, index) =>
								!item.subMenu ? (
									<MenuItem
										active={
											item.link === location.pathname ||
											(index === 0 && location.pathname === "/")
										}
										key={item.link}
										icon={item.icon}
										onClick={() => history.push(item?.link || "")}
										style={{
											font: "normal normal normal 14px Lato",
										}}
									>
										{item.title}
									</MenuItem>
								) : (
									<MenuItem
										key={item.link}
										style={{
											font: "normal normal normal 14px Lato",
										}}
									>
										<SubMenu
											suffix={<span className="badge yellow"></span>}
											title={item.title}
											icon={item.icon}
											style={{
												font: "normal normal normal 14px Lato",
											}}
											placeholder={undefined}
											onPointerEnterCapture={undefined}
											onPointerLeaveCapture={undefined}
										>
											{item.subItem?.map((item: ISidebar) => (
												<MenuItem
													active={item.link === location.pathname}
													onClick={() => history.push(item?.link || "")}
													style={{
														font: "normal normal normal 14px Lato",
													}}
												>
													{item.title}
												</MenuItem>
											))}
										</SubMenu>
									</MenuItem>
								),
							)}
						</Menu>
					</SidebarContent>
					<SidebarFooter>
						<Menu iconShape="square">
							<MenuItem
								icon={
									<Image
										width="20px"
										height="20px"
										src={IMAGES.sidebar.helpCenter}
									/>
								}
								style={{
									font: "normal normal normal 14px Lato",
								}}
							>
								<a
									href={`${process.env.WEB_URL_HELP_CENTER}`}
									target="_blank"
									style={{ color: "#FFFFFF" }}
									rel="noreferrer"
								>
									Help Center
								</a>
							</MenuItem>

							{FOOTER_SIDEBAR.map((item, index) =>
								!item.subMenu ? (
									<MenuItem
										onClick={() => history.push(item?.link || "")}
										active={item.link === location.pathname}
										key={item.link}
										icon={item.icon}
										style={{
											font: "normal normal normal 16px Lato",
										}}
									>
										{item.title}
									</MenuItem>
								) : (
									<MenuItem>
										<SubMenu
											suffix={<span className="badge yellow"></span>}
											title={item.title}
											icon={item.icon}
											style={{
												font: "normal normal normal 16px Lato",
											}}
											placeholder={undefined}
											onPointerEnterCapture={undefined}
											onPointerLeaveCapture={undefined}
										>
											{item.subItem?.map((item: ISidebar) => (
												<MenuItem
													key={item.link}
													active={item.link === location.pathname}
													onClick={() => history.push(item?.link || "")}
													style={{
														font: "normal normal normal 16px Lato",
													}}
												>
													{item.title}
												</MenuItem>
											))}
										</SubMenu>
									</MenuItem>
								),
							)}
							<MenuItem
								onClick={async () => {
									dispatch(setType(""));
									const currentRoute = `${location.pathname}${location.search}`;
									await logoutAndRedirect(currentRoute);
								}}
								icon={
									<Image width="20px" height="20px" src={IMAGES.sidebar.logOut} />
								}
								style={{
									font: "normal normal normal 14px Lato",
								}}
							>
								Logout
							</MenuItem>
							<Text
								style={{
									color: "#fff6f6",
									font: "normal normal normal 11px Lato",
								}}
							>
								Kapital DX™ Sdn Bhd Registration Number 202001022343 (1378663-V).
								All rights reserved.
							</Text>
						</Menu>
					</SidebarFooter>
				</ProSidebar>
			</WrapperProSidebar>
		</WrapperrSideBar>
	);
};

export default SidebarMoblie;
